<template>
  <v-card flat id="endPage">
    <!-- Buscador -->
    <v-row justify="center" class="my-4">
      <v-col cols="12" md="8">
        <producto-buscador
          ref="search"
          @process-buscador-producto="buscarProductos"
          @process-buscador-producto-select="buscarProductos"
        />
      </v-col>
    </v-row>

    <!-- Selector de categoría -->
    <v-row>
      <v-col>
        <ProductoCategoriaSelect
          @categoria-seleccionada="setCategoria"
          :uso="isCompra ? 'compra' : null"
          ref="refCategorias"
        />
      </v-col>
    </v-row>

    <!-- Productos / Skeleton -->
    <v-row>
      <v-col>
        <v-row>
          <!-- Skeleton mientras carga -->
          <template v-if="loading">
            <v-col v-for="n in 9" :key="n" cols="12" sm="4" class="mb-4">
              <v-skeleton-loader type="card" />
            </v-col>
          </template>

          <!-- Productos -->
          <productos-list-card-select
            v-if="productos.length > 0 && !loading"
            :productos="productos"
            :paginacion="paginacion"
            @set-page="setPage"
            :isCompra="isCompra"
            @process-producto="agregarProducto"
          />
        </v-row>

        <v-row
          v-if="busquedaIniciada && !loading && productos.length === 0"
          justify="center"
          class="my-8"
        >
          <v-col cols="12" md="6" class="text-center">
            <v-card color="#181818" class="pa-8" elevation="2" shaped>
              <v-icon size="48" color="grey lighten-1"
                >mdi-magnify-close</v-icon
              >
              <div class="mt-4" style="color: #b0b0b0; font-size: 18px">
                No se encontraron productos.
              </div>
              <div class="mt-2" style="color: #808080; font-size: 14px">
                Intenta buscar con otro término o categoría
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import ProductoCategoriaSelect from "@/components/shared/productos/componentes/ProductoCategoriaSelect.vue";
import ProductosListCardSelect from "@/components/producto/listar/productos.list.card.select.vue";
import ProductoBuscador from "@/components/producto/buscador/producto.buscador.vue";

export default {
  name: "ProductoBuscadorGeneral",
  components: {
    ProductoCategoriaSelect,
    ProductosListCardSelect,
    ProductoBuscador,
  },
  props: {
    isCompra: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paginacion: { page: 1, cantidad: 0, rowsPerPage: 9 },
      productos: [],
      paramsSeleccionados: {},
      loading: false,
      busquedaIniciada: false, // nueva bandera
      
    };
  },
  methods: {
    ...mapActions("productos", ["get_productos_for_params"]),

    setCategoria(categoria) {
      if (!categoria) {
        this.paramsSeleccionados = {};
        return;
      }

      this.$refs.search.clearSearch();
      this.paramsSeleccionados = {
        key: "categoria",
        value: categoria.name,
      };
      this.paginacion.page = 1;
      this.fetchProductos();
    },

    setPage(pageNumber) {
      this.paginacion.page = pageNumber;
      this.fetchProductos();
    },

    async buscarProductos(data) {
      this.paramsSeleccionados = {
        key: "q",
        value: data,
      };
      this.paginacion.page = 1;
      this.fetchProductos();
    },

    async fetchProductos() {
      this.loading = true;
       this.busquedaIniciada = true; // marcar que ya se hizo la búsqueda
      const { page, rowsPerPage } = this.paginacion;
      const paramKey = this.paramsSeleccionados.key;
      const paramValue = this.paramsSeleccionados.value;

      let url = `/productos/p?page=${page}&page_size=${rowsPerPage}`;
      if (paramKey && paramValue) {
        url += `&${paramKey}=${encodeURIComponent(paramValue)}`;
      }

      try {
        const response = await this.axios.get(url);
        if (response && response.data) {
          this.productos = response.data.results || [];
          this.paginacion.cantidad = response.data.count || 0;
        }
      } catch (error) {
        console.error("Error fetching productos:", error);
        this.productos = [];
      } finally {
        this.loading = false;
      }
    },

    agregarProducto(producto) {
      this.$emit("process-producto", producto);
    },
  },
};
</script>

<style scoped>
/* Opcional: margen entre cards */
.v-skeleton-loader {
  min-height: 200px;
}
</style>
